import { either, equals } from 'ramda';
import { createSelector } from 'reselect';

import { isAdminPortal, isAttendeeView, isEditor } from '@framework/app';
import { RESTRICTION_STATUS } from '@framework/constants/enums';

export const getCurrentContentView = (state) => state?.app?.contentView;

export const getCurrentAppSection = (state) => state?.app?.currentSection;

const getRestrictionStatus = (state) => state?.app?.restrictionStatus;

export const getIsRestrictionStatusAllowed = createSelector(
    getRestrictionStatus,
    equals(RESTRICTION_STATUS.ALLOWED)
);

export const getIsAdminPortalView = createSelector(getCurrentContentView, (contentView) =>
    isAdminPortal(contentView)
);

export const getIsEditorView = createSelector(getCurrentContentView, (contentView) =>
    isEditor(contentView)
);

export const getIsAttendeeView = createSelector(getCurrentContentView, (contentView) =>
    isAttendeeView(contentView)
);

export const getIsEditorOrAttendeeView = createSelector(
    getCurrentContentView,
    either(isEditor, isAttendeeView)
);
